'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FlatButton = require('material-ui/FlatButton');

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _Dialog = require('material-ui/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _VideoFormDialog = require('./VideoFormDialog');

var _VideoFormDialog2 = _interopRequireDefault(_VideoFormDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditVideoDialog = function (_React$Component) {
    _inherits(EditVideoDialog, _React$Component);

    function EditVideoDialog() {
        _classCallCheck(this, EditVideoDialog);

        return _possibleConstructorReturn(this, (EditVideoDialog.__proto__ || Object.getPrototypeOf(EditVideoDialog)).apply(this, arguments));
    }

    _createClass(EditVideoDialog, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                open = _props.open,
                video = _props.video,
                title = _props.title,
                onCancel = _props.onCancel,
                onSubmit = _props.onSubmit;


            return _react2.default.createElement(_VideoFormDialog2.default, {
                title: 'Editar V\xEDdeo',
                open: open,
                video: video,
                onCancel: onCancel,
                onSubmit: onSubmit,
                modal: true
            });
        }
    }]);

    return EditVideoDialog;
}(_react2.default.Component);

exports.default = EditVideoDialog;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9xdWVzdGlvbnMvRWRpdFZpZGVvRGlhbG9nLmpzIl0sIm5hbWVzIjpbIkVkaXRWaWRlb0RpYWxvZyIsInByb3BzIiwib3BlbiIsInZpZGVvIiwidGl0bGUiLCJvbkNhbmNlbCIsIm9uU3VibWl0IiwiUmVhY3QiLCJDb21wb25lbnQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7Ozs7Ozs7O0lBRXFCQSxlOzs7Ozs7Ozs7OztpQ0FDUjtBQUFBLHlCQUU4QyxLQUFLQyxLQUZuRDtBQUFBLGdCQUVHQyxJQUZILFVBRUdBLElBRkg7QUFBQSxnQkFFU0MsS0FGVCxVQUVTQSxLQUZUO0FBQUEsZ0JBRWdCQyxLQUZoQixVQUVnQkEsS0FGaEI7QUFBQSxnQkFFdUJDLFFBRnZCLFVBRXVCQSxRQUZ2QjtBQUFBLGdCQUVpQ0MsUUFGakMsVUFFaUNBLFFBRmpDOzs7QUFJTCxtQkFDSSw4QkFBQyx5QkFBRDtBQUNJLHVCQUFNLGlCQURWO0FBRUksc0JBQU1KLElBRlY7QUFHSSx1QkFBT0MsS0FIWDtBQUlJLDBCQUFVRSxRQUpkO0FBS0ksMEJBQVVDLFFBTGQ7QUFNSTtBQU5KLGNBREo7QUFVSDs7OztFQWZ3Q0MsZ0JBQU1DLFM7O2tCQUE5QlIsZSIsImZpbGUiOiJFZGl0VmlkZW9EaWFsb2cuanMiLCJzb3VyY2VSb290IjoiL3NyYyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgRmxhdEJ1dHRvbiBmcm9tICdtYXRlcmlhbC11aS9GbGF0QnV0dG9uJztcbmltcG9ydCBEaWFsb2cgZnJvbSAnbWF0ZXJpYWwtdWkvRGlhbG9nJztcbmltcG9ydCBUZXh0RmllbGQgZnJvbSAnbWF0ZXJpYWwtdWkvVGV4dEZpZWxkJztcbmltcG9ydCBWaWRlb0Zvcm1EaWFsb2cgZnJvbSAnLi9WaWRlb0Zvcm1EaWFsb2cnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBFZGl0VmlkZW9EaWFsb2cgZXh0ZW5kcyBSZWFjdC5Db21wb25lbnQge1xuICAgIHJlbmRlcigpIHtcblxuICAgICAgICBjb25zdCB7IG9wZW4sIHZpZGVvLCB0aXRsZSwgb25DYW5jZWwsIG9uU3VibWl0IH0gPSB0aGlzLnByb3BzO1xuXG4gICAgICAgIHJldHVybiAoXG4gICAgICAgICAgICA8VmlkZW9Gb3JtRGlhbG9nXG4gICAgICAgICAgICAgICAgdGl0bGU9XCJFZGl0YXIgVsOtZGVvXCJcbiAgICAgICAgICAgICAgICBvcGVuPXtvcGVufVxuICAgICAgICAgICAgICAgIHZpZGVvPXt2aWRlb31cbiAgICAgICAgICAgICAgICBvbkNhbmNlbD17b25DYW5jZWx9XG4gICAgICAgICAgICAgICAgb25TdWJtaXQ9e29uU3VibWl0fVxuICAgICAgICAgICAgICAgIG1vZGFsXG4gICAgICAgICAgICAvPlxuICAgICAgICApO1xuICAgIH1cbn0iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/client/components/questions/EditVideoDialog.js
// module id = 2554
// module chunks = 0